import React from 'react';
import block from 'propmods';
import { AlertIcon } from '../../icons/alert';
import { getSmartHomeTestingChecklistTexts, smartHomeTestingTitleText } from '../../locale/ru/smartHomeTesting';

import './SmartHomeTestPageChecklist.scss';

const b = block('SmartHomeTestPageChecklist');

interface ListItemProps {
    text: React.ReactNode;
}

const ListItem: React.FC<ListItemProps> = ({ text }) => {
    return <li {...b('list-item')}>- {text}</li>;
};

interface SmartHomeTestPageChecklistProps {
    displayIcon?: boolean;
}

export const SmartHomeTestPageChecklist: React.FC<SmartHomeTestPageChecklistProps> = ({ displayIcon }) => {
    return (
        <div {...b()}>
            {displayIcon ? (
                <div {...b('icon')}>
                    <AlertIcon />
                </div>
            ) : null}
            <div {...b('content')}>
                <h3 {...b('title')}>{smartHomeTestingTitleText}</h3>
                <ul {...b('list')}>
                    {getSmartHomeTestingChecklistTexts().map((text, i) => {
                        return <ListItem key={i} text={text} />;
                    })}
                </ul>
            </div>
        </div>
    );
};
